
import React, { useContext, Children } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from 'react-router-dom'
import Button from '../formfields/Button'
import Spinner from '../ui-elements/Spinner'
import YellowAlert from '../ui-elements/YellowAlert'
import { useVideo } from '../context/video/VideoContext'
import { useVoice } from '../context/voice/VoiceContext'



type Props = {
    question: ObjectStringKeyAnyValue
    questionId?: string
    checklistId?: string
    setQuestionAnswer: React.Dispatch<React.SetStateAction<any>>
    defaultValue: any
    handleChangeMultiText: AnyFunction
    lastMultiTextFieldFromSpeech: string | null
}

function QuestionMultipleTextFields({
    question,
    questionId,
    checklistId,
    setQuestionAnswer,
    defaultValue,
    handleChangeMultiText,
    lastMultiTextFieldFromSpeech
}: Props) {

    const {
        tableData,
        t
    } = useContext(GlobalContext)

    const {
        spokenAnswer
    } = useVoice()

    return <div className={`w-full flex flex-col gap-4`}>

        {question.QuestionFieldNames ? question.QuestionFieldNames.map((fieldName: string, index: number) => {
            const shouldHighlight = lastMultiTextFieldFromSpeech && lastMultiTextFieldFromSpeech.toLowerCase() === fieldName.toLowerCase()
            return <div key={index} className={`flex flex-col gap-2`}>
                <p className={`font-bold`}>{fieldName}</p>
                <div className={`flex flex-row gap-2`}>
                    <div
                        className={`
                        ${shouldHighlight ?
                                `  border-black ` :
                                `  border-gray-300 `
                            }
                        
                        bg-white text-center drop-shadow-lg border text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full flex flex-row items-center justify-between`}
                    >
                        <input
                            className={`bg-transparent w-full text-lg px-5 py-3`}
                            onChange={(e) => handleChangeMultiText(fieldName, e.target.value)}
                            type={`text`}
                            value={defaultValue && defaultValue[fieldName] !== null && defaultValue[fieldName] !== undefined ? defaultValue[fieldName] : ''}
                        />
                        {shouldHighlight && <div className={`text-2xl p-2`}>🎤</div>}
                    </div>
                </div>
            </div>
        }) :
            <YellowAlert>{t('QuestionPages.QuestionMultipleTextFields.noFieldNames')}</YellowAlert>}
    </div>
}
export default QuestionMultipleTextFields